import { css } from '@emotion/react';

const twoColumnStyles = css`
    display: flex;
    justify-content: space-between;
`;

export const themeTwoColumnStyles = css`
    display: flex;
    justify-content: space-between;
    font-family: var(--font-family-regular);
    font-size: var(--font-size-regular);
`;

export default twoColumnStyles;
